import type { GlobalThemeOverrides } from 'naive-ui'
import { COLORS, toRGB } from "./colors";

/**
 * Naive UI theme overrides using BP Tailwind-based RGB color values
 */
export const THEME_OVERRIDES: GlobalThemeOverrides = {
    common: {
        errorColor: toRGB(COLORS.error.bg),
        errorColorHover: toRGB(COLORS.error.bgHover),
        errorColorPressed: toRGB(COLORS.error.bg),
        errorTextColor: toRGB(COLORS.error.text),
        errorBorder: `1px solid ${toRGB(COLORS.error.border)}`,

        warningColor: toRGB(COLORS.warning.bg),
        warningColorHover: toRGB(COLORS.warning.bgHover),
        warningColorPressed: toRGB(COLORS.warning.bg),
        warningTextColor: toRGB(COLORS.warning.text),
        warningBorder: `1px solid ${toRGB(COLORS.warning.border)}`,

        infoColor: toRGB(COLORS.blue.bg),
        infoColorHover: toRGB(COLORS.blue.bgHover),
        infoColorPressed: toRGB(COLORS.blue.bg),
        infoTextColor: toRGB(COLORS.blue.text),
        infoBorder: `1px solid ${toRGB(COLORS.blue.border)}`,

        successColor: toRGB(COLORS.green.bg),
        successColorHover: toRGB(COLORS.green.bgHover),
        successColorPressed: toRGB(COLORS.green.bg),
        successTextColor: toRGB(COLORS.green.text),
        successBorder: `1px solid ${toRGB(COLORS.green.border)}`,

        primaryColor: toRGB(COLORS.green.bg)
    }
}